import { useEffect, useState } from "react";
import CheckBox from "./CheckBox";
import InputData from "./InputData";
import Dropdown from "./Dropdown";
import { inputOnEnter, dashboardStoreFilter } from "../js/utils";
import { useStockAdjustmentReasons } from "../hooks/useStockAdjustmentReasons";
import DateInput from "./DateInput";

export function DashboardStorePanelFilterSectionReportType({
  reportType,
  onChange,
}) {
  const [data, setData] = useState(dashboardStoreFilter);
  const reasonsList = [{ id: "", text: "" }, ...useStockAdjustmentReasons()];

  function clearAll() {
    setData(dashboardStoreFilter);
  }

  useEffect(() => {
    onChange(data);
  }, [data]);

  useEffect(() => {
    setData(dashboardStoreFilter);
  }, [reportType]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div className="opt-table-title opt-table-title-dash-stats">
          Filtros por tipo de informe
        </div>
        {!reportType.tipologias && (
          <button
            className="cell-label"
            tabIndex={-1}
            style={{ width: "150px" }}
            onClick={clearAll}
          >
            Limpiar selección
          </button>
        )}
      </div>
      <div
        className="opt-table-content grid-14"
        id="dashboard-filter-report-type"
      >
        <div className="cell cell-start-content">
          {reportType.inventarios
            ? "Stock positivo"
            : reportType.ajustes
              ? "Positivos"
              : ""}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <CheckBox
              tabIndex={13}
              active={data.stockPositivo}
              onClick={() => {
                setData((prev) => ({
                  ...prev,
                  stockPositivo: !prev.stockPositivo,
                }));
              }}
            ></CheckBox>
          ) : reportType.ajustes ? (
            <CheckBox
              tabIndex={13}
              active={data.positivos}
              onClick={() => {
                setData((prev) => ({
                  ...prev,
                  positivos: !prev.positivos,
                }));
              }}
            ></CheckBox>
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios || reportType.compras
            ? "Fecha compra desde"
            : reportType.ventas
              ? "Fecha venta desde"
              : reportType.traspasos
                ? "Fecha traspaso desde"
                : reportType.ajustes
                  ? "Fecha ajuste desde"
                  : ""}
        </div>
        <div className="cell">
          {reportType.inventarios || reportType.compras ? (
            <DateInput
              max="9999-12-31"
              tabIndex={15}
              className="input-field"
              value={data.fechaCompraDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaCompraDesde: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.ventas ? (
            <DateInput
              max="9999-12-31"
              tabIndex={15}
              className="input-field"
              value={data.fechaVentaDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaVentaDesde: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.traspasos ? (
            <DateInput
              max="9999-12-31"
              tabIndex={15}
              className="input-field"
              value={data.fechaTraspasoDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaTraspasoDesde: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.ajustes ? (
            <DateInput
              max="9999-12-31"
              tabIndex={15}
              className="input-field"
              value={data.fechaAjusteDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaAjusteDesde: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios ? (
            "Fecha límite desde"
          ) : reportType.compras ? (
            "Fecha albarán desde"
          ) : reportType.ajustes ? (
            <div className="data-field">
              <span className="label">Motivo</span>
              <Dropdown
                tabIndex={17}
                optionList={reasonsList}
                size={2}
                op={data.motivo}
                onChange={(e) => {
                  setData((prev) => ({ ...prev, motivo: e.text }));
                }}
              ></Dropdown>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <DateInput
              max="9999-12-31"
              tabIndex={17}
              className="input-field"
              value={data.fechaLimiteDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaLimiteDesde: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.compras ? (
            <DateInput
              max="9999-12-31"
              tabIndex={17}
              className="input-field"
              value={data.fechaAlbaranDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaAlbaranDesde: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios ? "PCN desde" : ""}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <InputData
              type="type-float2"
              size={0}
              tabIndex={19}
              input={data.pcnDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  pcnDesde: e,
                }));
              }}
            ></InputData>
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios ? "PVP desde" : ""}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <InputData
              type="type-float2"
              size={0}
              tabIndex={21}
              input={data.pvpDesde}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  pvpDesde: e,
                }));
              }}
            ></InputData>
          ) : (
            ""
          )}
        </div>
        <div className="cell cell-start-content">
          {reportType.inventarios
            ? "Stock mínimo"
            : reportType.ajustes
              ? "Negativos"
              : ""}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <CheckBox
              tabIndex={14}
              active={data.stockMinimo}
              onClick={() => {
                setData((prev) => ({
                  ...prev,
                  stockMinimo: !data.stockMinimo,
                }));
              }}
            ></CheckBox>
          ) : reportType.ajustes ? (
            <CheckBox
              tabIndex={14}
              active={data.negativos}
              onClick={() => {
                setData((prev) => ({
                  ...prev,
                  negativos: !data.negativos,
                }));
              }}
            ></CheckBox>
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios || reportType.compras
            ? "Fecha compra hasta"
            : reportType.ventas
              ? "Fecha venta hasta"
              : reportType.traspasos
                ? "Fecha traspaso hasta"
                : reportType.ajustes
                  ? "Fecha ajuste hasta"
                  : ""}
        </div>
        <div className="cell">
          {reportType.inventarios || reportType.compras ? (
            <DateInput
              max="9999-12-31"
              tabIndex={16}
              className="input-field"
              value={data.fechaCompraHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaCompraHasta: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.ventas ? (
            <DateInput
              max="9999-12-31"
              tabIndex={16}
              className="input-field"
              value={data.fechaVentaHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaVentaHasta: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.traspasos ? (
            <DateInput
              max="9999-12-31"
              tabIndex={16}
              className="input-field"
              value={data.fechaTraspasoHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaTraspasoHasta: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.ajustes ? (
            <DateInput
              max="9999-12-31"
              tabIndex={16}
              className="input-field"
              value={data.fechaAjusteHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaAjusteHasta: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios
            ? "Fecha límite hasta"
            : reportType.compras
              ? "Fecha albarán hasta"
              : ""}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <DateInput
              max="9999-12-31"
              tabIndex={18}
              className="input-field"
              value={data.fechaLimiteHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaLimiteHasta: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : reportType.compras ? (
            <DateInput
              max="9999-12-31"
              tabIndex={18}
              className="input-field"
              value={data.fechaAlbaranHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  fechaAlbaranHasta: e.target.value,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            />
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios ? "PCN hasta" : ""}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <InputData
              type="type-float2"
              size={0}
              tabIndex={20}
              input={data.pcnHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  pcnHasta: e,
                }));
              }}
            ></InputData>
          ) : (
            ""
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          {reportType.inventarios ? "PVP hasta" : ""}
        </div>
        <div className="cell">
          {reportType.inventarios ? (
            <InputData
              type="type-float2"
              size={0}
              tabIndex={22}
              input={data.pvpHasta}
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  pvpHasta: e,
                }));
              }}
            ></InputData>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
